(function () {
	const container_el = document.getElementById(`js-ideas-content`);
	if (!container_el) {
		return;
	}

	const button_els = container_el.querySelectorAll(`nav button`);
	const tab_els = container_el.querySelectorAll(`.inner .block`);

	function on_click(e) {
		const button_el = e.currentTarget;
		if (button_el.classList.contains(`active`)) {
			return;
		}

		for (let i = 0; i < button_els.length; i++) {
			if (button_els[i].dataset.idx === button_el.dataset.idx) {
				button_els[i].classList.add(`active`);
			} else {
				button_els[i].classList.remove(`active`);
			}
		}

		for (let i = 0; i < tab_els.length; i++) {
			const tab_el = tab_els[i];

			if (tab_el.dataset.idx === button_el.dataset.idx) {
				tab_el.classList.add(`active`);
			} else {
				tab_el.classList.remove(`active`);
			}
		}
	}

	for (let i = 0; i < button_els.length; i++) {
		button_els[i].addEventListener(`click`, on_click);
	}
})();

(function () {
	const container_el = document.getElementById(`js-ideas-content`);
	if (!container_el) {
		return;
	}

	function Progress(progress_el) {
		const text_el = progress_el.querySelector(`span`);

		const bar_el = progress_el.querySelector(`.bar span`);

		const parent_el = progress_el.closest(`.block`);

		const input_els = parent_el.querySelectorAll(`input[type="checkbox"]`);

		function update() {
			const checked_input_els = parent_el.querySelectorAll(`input[type="checkbox"]:checked`);

			text_el.textContent = `${checked_input_els.length}/${input_els.length}`;

			bar_el.style.width = `${(checked_input_els.length / input_els.length) * 100}%`;
		}

		for (let i = 0; i < input_els.length; i++) {
			input_els[i].addEventListener(`change`, update);
		}

		update();
	}

	const progress_els = container_el.getElementsByClassName(`progress`);
	for (let i = 0; i < progress_els.length; i++) {
		new Progress(progress_els[i]);
	}
})();
